import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ERoleAdminString } from 'src/app/shared/data/role.enum';
import { PermissionsGuard } from 'src/app/shared/guards/permissions.guard';
import { ConsultasListComponent } from './pages/consultas-list/consultas-list.component';
import { MarcarConsultaComponent } from './pages/marcar-consulta/marcar-consulta.component';

const routes: Routes = [
  { path: '', component: ConsultasListComponent },
  {
    path: 'marcar-consulta/:id',
    title: 'Marcar Consulta',
    component: MarcarConsultaComponent,
    canActivate: [PermissionsGuard],
    data: [
      {
        role: [ERoleAdminString.Doctor],
        claim: {
          nome: 'consultas',
          valor: 'appointments.create'
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ConsultasRoutingModule {}
